"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTemplatesInfinite = void 0;
var infinite_1 = __importDefault(require("swr/infinite"));
var useAccountTemplates_1 = require("Common/Templates/useAccountTemplates");
function useTemplatesInfinite(apiBaseUrl, query, _a) {
    var _b = _a === void 0 ? { shouldFetch: true } : _a, shouldFetch = _b.shouldFetch;
    return (0, infinite_1.default)(function (pageIndex, previousPageData) {
        if (!shouldFetch || (previousPageData && !previousPageData.pagination.hasNext)) {
            return null;
        }
        else {
            return __assign(__assign({}, query), { page: pageIndex + 1 });
        }
    }, function (query) { return (0, useAccountTemplates_1.fetchTemplates)((0, useAccountTemplates_1.getUrl)(apiBaseUrl), query); });
}
exports.useTemplatesInfinite = useTemplatesInfinite;
